<template>
    <v-app>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div v-if="loading_page === false">
            <div class="color_header_cartmenu" :style="{ background: bg_color }">
                <div class="d-flex justify-space-between align-center pa-3">
                    <div class="d-flex align-center">
                        <div class="img_cart_header_cartmenu">
                            <img src="@/assets/shopping-cart.png">
                        </div>
                        <div class="ml-2 color_title_cartmenu">ตะกร้าอาหารของฉัน</div>
                    </div>
                    <div class="link_back_cartmenu"
                        @click="$router.push('/' + $route.params.type + '/' + $route.params.id + '/' + $route.params.token + '/' + $route.params.typeorder)">
                        <div>
                            <v-icon color="white" size="30">mdi-close</v-icon>
                        </div>
                    </div>
                </div>
            </div>
            <div class="detail_cartmenu">
                <div class="d-flex justify-space-between mb-2">
                    <div>
                        Order # {{ table_order }}
                    </div>
                    <div v-if="$route.params.typeorder == 'pre_order'">
                        คิวที่ {{ table_name }}
                    </div>
                    <div v-else>
                        โต๊ะ {{ table_name }}
                    </div>
                </div>
                <div class="mb-2 text-center" v-if="$route.params.type == 'buffetuser'">
                    <div class="color_note_red_cartmenu">
                        **ทานไม่หมด ปรับเงิน! ตามราคาอาหารแบบอลาคาส**
                    </div>
                </div>
                <div class="mb-2 cart_detail_cart_menu" v-for="(cart, key) in $store.state.cartListUser" :key="key">
                    <v-card class="pa-3 mr-1" color="#eeeeee" @click="editCartListUser(cart.id, cart.foodmenu_id)">
                        <div class="d-flex justify-space-between align-center">
                            <div class="d-flex align-center">
                                <div class="mr-2 pa-3">{{ Intl.NumberFormat().format(cart.amount) }}</div>
                                <div>{{ cart.name }}
                                    <div class="topping_food_cartmenu">
                                        <ul>
                                            <li v-for="(topping_name_list, key_topping) in cart.topping_name"
                                                :key="key_topping">
                                                <span v-if="cart.amount_topping[key_topping]"
                                                    class="amount_list_topping_cartmenu">{{
                                                        cart.amount_topping[key_topping] }}</span> {{ topping_name_list }}
                                                (ราคา {{ cart.toppingprice_list[key_topping] }} ฿)
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="note_cartmenu" v-if="cart.description">
                                        หมายเหตุ : {{ cart.description }}
                                    </div>
                                </div>
                            </div>
                            <div>
                                {{ Intl.NumberFormat().format(cart.total_price + (cart.toppingprice * cart.amount)) }} ฿
                            </div>
                        </div>
                    </v-card>
                    <v-card class="delete_cart_detail_cart_menu ml-1">
                        <div>
                            <v-icon color="error" size="40" @click="deleteCartListUser(cart.id)">mdi-close</v-icon>
                        </div>
                    </v-card>
                </div>
            </div>

            <div class="pa-3 confirm_cartmenu">
                <div class="d-flex justify-center">
                    <div class="result_cart_all_cartmenu mr-2">
                        <img src="@/assets/hand.png">
                    </div>
                    <h2>ราคารวม {{ Intl.NumberFormat().format($store.state.cartListUser.reduce((sum, item) => {
                        return sum + item.total_price + (item.toppingprice * item.amount);
                    }, 0)) }} บาท</h2>
                </div>
                <v-btn width="100%" height="55" class="titlefont_cartmenu white--text" :style="{ background: bg_color }"
                    @click="sendFood()">ยืนยันการสั่งอาหาร</v-btn>
            </div>

            <v-dialog v-model="alert_show_add" persistent max-width="600">
                <v-card>
                    <v-card-title>
                        สำเร็จ
                    </v-card-title>

                    <v-card-text>
                        สั่งอาหารเรียบร้อย กรุณารออาหารสักครู่
                        <!-- สั่งอาหารเรียบร้อย กรุณารออาหาร 10-20 นาทีนะคะ -->
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="black" text @click="confirmSuccess()">
                            ตกลง
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        <EditToppingMenu />
    </v-app>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import EditToppingMenu from '@/components/menuuser/addmenu/EditToppingMenu.vue'
export default {
    name: 'cartMenu',
    components: {
        EditToppingMenu
    },
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            bg_color: 'linear-gradient(to top, #038cc1 , #55c0e9)',
            table_name: '',
            table_order: '',
            alert_show_add: false

        }
    },
    methods: {
        async colorRestaurant() {
            HTTP.get(`/showColor?store_id=${this.$route.query.store_id}&token=`+this.$route.params.token)
                .then((response) => {
                    if (response.data.successful === true) {
                        this.bg_color = response.data.color_code
                        this.loading_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                    if (error.response.status === 500) {
                        // this.$router.push('/nametakeoutuser')
                    }

                })
        },
        async editCartListUser(id, foodmenu_id) {
            const dataList = {
                id: id,
                foodmenu_id: foodmenu_id,
                type_cart: 'cart_user',
            }
            this.$root.$emit('getDetail', dataList)
        },
        async deleteCartListUser(id) {
            const deleteId = {
                id: id
            }
            this.$store.commit('deleteCartListUser', deleteId)
        },
        async tableDetail() {

            await HTTP.get(`/customer/open-buffet/` + this.$route.params.id + `/` + this.$route.params.typeorder + `?store_id=${this.$route.query.store_id}&token=`+this.$route.params.token, {
                headers: {
                    "Authorization": `Bearer ${this.$store.state.token}`
                }
            })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.table_name = response.data.opentable_detail.name
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                    if (error.response.status === 500) {
                        // this.$router.push('/thankyouuser')
                    }

                })
            await HTTP.get(`/customer/order-number/` + this.$route.params.id + `/` + this.$route.params.typeorder + `?store_id=${this.$route.query.store_id}&token=`+this.$route.params.token, {
                headers: {
                    "Authorization": `Bearer ${this.$store.state.token}`
                }
            })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.table_order = response.data.order_number
                        this.loading_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                    if (error.response.status === 500) {
                        // this.$router.push('/thankyouuser')
                    }

                })

        },
        async sendFood() {
            if (this.$store.state.cartListUser.length > 0) {
                this.loading_page = true
                let foodmenu_id = []
                let amount = []
                let price = []
                let total_price = []
                let toping_id = []
                let topping_price = []
                let description = []
                let type_status = []
                this.$store.state.cartListUser.forEach(detail => {
                    foodmenu_id.push(detail.foodmenu_id)
                    amount.push(detail.amount)
                    price.push(detail.price)
                    total_price.push(detail.total_price)
                    topping_price.push(detail.toppingprice)
                    toping_id.push(detail.topping_arr_list)
                    description.push(detail.description)
                    type_status.push(detail.type)
                });

                HTTP.post(`/customer/order-create/` + this.$route.params.id + `/` + this.$route.params.typeorder + `?store_id=${this.$route.query.store_id}&token=`+this.$route.params.token, {
                    foodmenu_id: foodmenu_id,
                    amount: amount,
                    price: price,
                    total_price: total_price,
                    toping_id: toping_id,
                    type_order: 0,
                    topping_price: topping_price,
                    description: description,
                    type_status: type_status,
                }, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                    .then((response) => {
                        if (response.data.successful === true) {
                            this.loading_page = false
                            this.alert_show_add = true
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })

            }
        },
        async confirmSuccess() {
            this.$store.commit('clearCartListUser')
            this.$router.push('/' + this.$route.params.type + '/' + this.$route.params.id + '/' + this.$route.params.token + '/' + this.$route.params.typeorder)
        }
    },
    created() {
        HTTP.get(`/POS/table/check_token_opentable/` + this.$route.params.id + `/` + this.$route.params.token + `/` + this.$route.params.typeorder, {
            headers: {
                "Authorization": `Bearer ${this.$store.state.token}`
            }
        })
            .then((response) => {
                if (response.data.successful === false) {
                    this.$store.commit('clearCartListUser')
                    this.$store.commit('clearCartTakeOutTableListUser')
                    this.$store.commit('clearCartListUserTakeOut')
                    this.$store.commit('clearCartOrderOnlineUser')
                    this.$router.push('/thankyouuser')
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
                if (error.response.status === 500) {
                    this.$store.commit('clearCartListUser')
                    this.$store.commit('clearCartTakeOutTableListUser')
                    this.$store.commit('clearCartListUserTakeOut')
                    this.$store.commit('clearCartOrderOnlineUser')
                    this.$router.push('/thankyouuser')
                }

            })
    },
    mounted() {
        this.colorRestaurant()
        this.tableDetail()
    }
}
</script>

<style scoped>
.color_header_cartmenu {
    background: linear-gradient(to top, #038cc1, #55c0e9);
    position: fixed;
    width: 100%;
    z-index: 10;
}

.img_cart_header_cartmenu {
    width: 50px;
}

.img_cart_header_cartmenu>img {
    max-width: 100%;
}

.color_title_cartmenu {
    color: #fff;
}

.link_back_cartmenu {
    cursor: pointer;
}

.detail_cartmenu {
    height: 100%;
    padding: 100px 12px 150px !important
}

.confirm_cartmenu {
    position: fixed;
    width: 100%;
    bottom: 0;
    background: #fff;
}

.titlefont_cartmenu {
    font-size: 22px !important;
}

.topping_food_cartmenu {
    font-size: 16px;
}

.color_note_red_cartmenu {
    color: #ff5252;
}

.result_cart_all_cartmenu {
    width: 50px;
}

.result_cart_all_cartmenu>img {
    max-width: 100%;
}

/* .amount_list_topping_cartmenu{
     color: #ff5252;
} */

.note_cartmenu {
    color: #ff5252;
}

.cart_detail_cart_menu {
    display: grid;
    grid-template-columns: 80% 20%;
}

.delete_cart_detail_cart_menu>div,
.delete_cart_detail_cart_menu>div>button {
    height: 100%;
    width: 100%;
}
</style>
